<div class="min-h-screen bg-[#F3F6F9] font-sans antialiased text-slate-800 p-4 lg:p-6">
      <div class="max-w-[1400px] mx-auto space-y-4">

            <div
                  class="bg-white rounded-sm shadow-sm border border-slate-200 px-5 py-3 flex items-center justify-between">
                  <div>
                        <h2
                              class="text-[12px] font-black text-slate-800 uppercase tracking-wider flex items-center gap-2">
                              <span class="w-1.5 h-4 bg-blue-600 rounded-full"></span>
                              System Navigation & Access Control
                        </h2>
                  </div>
                  <div class="flex gap-2">
                        <button *ngIf="showForm || selectedMenu" (click)="goBack()"
                              class="bg-slate-100 hover:bg-slate-200 text-slate-600 px-4 py-1.5 rounded-sm text-[10px] font-bold uppercase tracking-widest transition-all">
                              ← Back to List
                        </button>
                        <button (click)="openCreate()"
                              class="bg-[#3699FF] hover:bg-[#187DE4] text-white px-4 py-1.5 rounded-sm text-[10px] font-bold uppercase tracking-widest transition-all shadow-sm active:scale-95">
                              + New Node
                        </button>
                  </div>
            </div>

            <div class="bg-white rounded-sm shadow-sm border border-slate-200 overflow-hidden">

                  <div *ngIf="!showForm && !selectedMenu" class="animate-in fade-in duration-300">
                        <table class="w-full text-left border-collapse">
                              <thead class="bg-slate-50/80 border-b border-slate-200">
                                    <tr>
                                          <th
                                                class="px-6 py-3 text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                                Node Name</th>
                                          <th
                                                class="px-6 py-3 text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                                System Code</th>
                                          <th
                                                class="px-6 py-3 text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                                Route</th>
                                          <th
                                                class="px-6 py-3 text-[10px] font-black text-slate-500 uppercase tracking-widest text-right">
                                                Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let m of menus" class="hover:bg-blue-50/30 transition-colors group">
                                          <td class="px-6 py-3">
                                                <div class="flex items-center gap-3">

                                                      <span class="text-[12px] font-bold text-slate-700">{{ m.name
                                                            }}</span>
                                                </div>
                                          </td>
                                          <td class="px-6 py-3 text-[10px] font-mono text-slate-500">{{ m.code }}</td>
                                          <td class="px-6 py-3 text-[11px] text-slate-400">{{ m.route }}</td>
                                          <td class="px-6 py-3 text-right">
                                                <div class="flex justify-end gap-2">
                                                      <button (click)="selectMenu(m)"
                                                            class="px-3 py-1 text-[9px] font-bold uppercase bg-slate-100 text-slate-600 rounded hover:bg-blue-600 hover:text-white transition-all">Security</button>

                                                      <button (click)="openEdit(m, $event)"
                                                            class="p-1.5 text-slate-400 hover:text-blue-600 transition-colors">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path stroke-width="2"
                                                                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                            </svg>
                                                      </button>

                                                      <button (click)="deleteMenu(m.id, $event)"
                                                            class="p-1.5 text-slate-400 hover:text-red-600 transition-colors">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path stroke-width="2"
                                                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                            </svg>
                                                      </button>
                                                </div>
                                          </td>
                                    </tr>
                              </tbody>
                        </table>
                  </div>
                  <!-- <div *ngIf="showForm"
                        class="max-w-[1100px] mx-auto p-5 animate-in slide-in-from-bottom-2 duration-300">

                        <div class="flex items-center gap-3 mb-6 border-b border-slate-100 pb-4">
                              <div
                                    class="h-9 w-9 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center">
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path stroke-width="2" d="M12 4v16m8-8H4" />
                                    </svg>
                              </div>
                              <div>
                                    <h3 class="text-[13px] font-black text-slate-800 uppercase tracking-tight">
                                          {{ menuModel.id ? 'Modify Node' : 'Register New Node' }}
                                    </h3>
                                    <p class="text-[9px] text-slate-400 font-bold uppercase tracking-wide">Update system
                                          hierarchy</p>
                              </div>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4">

                             

                              <div class="space-y-1 relative">
                                    <label
                                          class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Organization </label>
                                    <div class="relative">
                                          <input type="text" [(ngModel)]="orgSearch" (focus)="showOrgDropdown = true"
                                                (input)="onOrgSearch()" placeholder="Search organization..."
                                                
                                                class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all shadow-sm">
                                          <div class="absolute right-2.5 top-2.5 text-slate-300 pointer-events-none">
                                                <svg class="w-3 h-3" fill="none" stroke="currentColor"
                                                      viewBox="0 0 24 24">
                                                      <path stroke-width="3" d="M19 9l-7 7-7-7" />
                                                </svg>
                                          </div>
                                    </div>

                                    <div *ngIf="showOrgDropdown && organisations.length > 0"
                                          class="absolute left-0 w-full mt-1 bg-white border border-slate-200 shadow-lg rounded-sm max-h-48 overflow-y-auto z-[120]">
                                          <div (click)="selectOrg(null)"
                                                class="px-3 py-2 text-[10px] font-bold text-blue-600 hover:bg-blue-50 cursor-pointer border-b border-slate-100 uppercase">
                                                (Clear)
                                          </div>
                                          <div *ngFor="let org of organisations" (click)="selectOrg(org)"
                                                class="px-3 py-1.5 text-[11px] text-slate-700 hover:bg-slate-50 cursor-pointer flex justify-between border-b border-slate-50 last:border-0">
                                                <span [class.font-black]="org.id === menuModel.orgId">{{ org.name
                                                      }}</span>
                                                <span *ngIf="org.id === menuModel.orgId"
                                                      class="text-blue-600 text-[9px] font-bold">SET</span>
                                          </div>
                                    </div>
                                    <div *ngIf="showOrgDropdown" (click)="showOrgDropdown = false"
                                          class="fixed inset-0 z-[115] bg-transparent"></div>
                              </div>
                              
                              <div class="space-y-1">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">System
                                          Module</label>
                                    <select [(ngModel)]="menuModel.moduleCode" (change)="onModuleChange()"
                                          class="w-full h-8 px-2 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all shadow-sm">
                                          <option [ngValue]="null">-- Select Module --</option>
                                          <option *ngFor="let m of modules" [value]="m.code">{{  m.code }}
                                          </option>
                                    </select>
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Linked
                                          Entity</label>
                                    <div class="relative">
                                          <input type="text" [(ngModel)]="entitySearch"
                                                (focus)="showEntityDropdown = true" (input)="showEntityDropdown = true"
                                                [disabled]="!menuModel.moduleCode"
                                                placeholder="{{ menuModel.moduleCode ? 'Search entity...' : 'Select module first' }}"
                                                class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all shadow-sm disabled:bg-slate-50">
                                    </div>

                                    <div *ngIf="showEntityDropdown && filteredEntities.length > 0"
                                          class="absolute left-0 w-full mt-1 bg-white border border-slate-200 shadow-lg rounded-sm max-h-48 overflow-y-auto z-[130]">
                                          <div (click)="selectEntity(null)"
                                                class="px-3 py-2 text-[10px] font-bold text-blue-600 hover:bg-blue-50 cursor-pointer border-b border-slate-100 uppercase">
                                                (None)
                                          </div>
                                          <div *ngFor="let e of filteredEntities" (click)="selectEntity(e)"
                                                class="px-3 py-1.5 text-[11px] text-slate-700 hover:bg-slate-50 cursor-pointer flex justify-between border-b border-slate-50 last:border-0">
                                                <span [class.font-black]="e.id === menuModel.entityId">{{ e.name
                                                      }}</span>
                                                <span class="text-slate-300 text-[9px] font-mono">{{ e.code }}</span>
                                          </div>
                                    </div>
                                    <div *ngIf="showEntityDropdown" (click)="showEntityDropdown = false"
                                          class="fixed inset-0 z-[125]"></div>
                              </div>
                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Parent
                                          Node</label>
                                    <div class="relative">
                                          <input type="text" name="parentSearch" [(ngModel)]="parentSearch"
                                                (focus)="showParentDropdown = true" (input)="showParentDropdown = true"
                                                placeholder="Search menu name..."
                                                class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all shadow-sm">
                                          <div class="absolute right-2.5 top-2.5 text-slate-300 pointer-events-none">
                                                <svg class="w-3 h-3" fill="none" stroke="currentColor"
                                                      viewBox="0 0 24 24">
                                                      <path stroke-width="3" d="M19 9l-7 7-7-7" />
                                                </svg>
                                          </div>
                                    </div>

                                    <div *ngIf="showParentDropdown"
                                          class="absolute left-0 w-full mt-1 bg-white border border-slate-200 shadow-lg rounded-sm max-h-48 overflow-y-auto z-[110]">
                                          <div (click)="selectParent(null)"
                                                class="px-3 py-2 text-[10px] font-bold text-blue-600 hover:bg-blue-50 cursor-pointer border-b border-slate-100 uppercase">
                                                (None)
                                          </div>
                                          <div *ngFor="let m of filteredParentMenus" (click)="selectParent(m)"
                                                class="px-3 py-1.5 text-[11px] text-slate-700 hover:bg-slate-50 cursor-pointer flex justify-between border-b border-slate-50 last:border-0">
                                                <span [class.font-black]="m.id === menuModel.parentId">{{ m.name
                                                      }}</span>
                                                <span *ngIf="m.id === menuModel.parentId"
                                                      class="text-blue-600 text-[9px] font-bold">SET</span>
                                          </div>
                                    </div>
                                    <div *ngIf="showParentDropdown" (click)="showParentDropdown = false"
                                          class="fixed inset-0 z-[100] bg-transparent">
                                    </div>
                              </div>
                              <div class="space-y-1">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Display
                                          Name</label>
                                    <input [(ngModel)]="menuModel.name"
                                          class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none transition-all shadow-sm"
                                          placeholder="e.g. Dashboard">
                              </div>

                              <div class="space-y-1">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Identifier
                                          Code</label>
                                    <input [(ngModel)]="menuModel.code"
                                          class="w-full h-8 px-3 text-[11px] font-mono border border-slate-200 rounded-sm focus:border-blue-500 outline-none transition-all shadow-sm"
                                          placeholder="DASHBOARD_VIEW">
                              </div>

                              <div class="space-y-1">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Icon
                                          Class</label>
                                    <input [(ngModel)]="menuModel.icon"
                                          class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none transition-all shadow-sm"
                                          placeholder="fas fa-home">
                              </div>

                              <div class="space-y-1">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Route
                                          Path</label>
                                    <input [(ngModel)]="menuModel.route"
                                          class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none transition-all shadow-sm"
                                          placeholder="/dashboard">
                              </div>
                        </div>

                        <div class="mt-8 pt-5 border-t border-slate-100 flex gap-3">
                              <button (click)="saveMenu()"
                                    class="bg-blue-600 text-white px-6 h-9 rounded-sm text-[10px] font-bold uppercase tracking-widest hover:bg-blue-700 transition-all shadow-sm active:scale-95">
                                    Save Configuration
                              </button>
                              <button (click)="goBack()"
                                    class="bg-slate-100 text-slate-600 px-6 h-9 rounded-sm text-[10px] font-bold uppercase tracking-widest hover:bg-slate-200 transition-all">
                                    Discard
                              </button>
                        </div>
                  </div> -->
                  <div *ngIf="showForm"
                        class="max-w-[1100px] mx-auto p-5 animate-in slide-in-from-bottom-2 duration-300">

                        <div class="flex items-center gap-3 mb-6 border-b border-slate-100 pb-4">
                              <div
                                    class="h-9 w-9 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center">
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path stroke-width="2" d="M12 4v16m8-8H4" />
                                    </svg>
                              </div>
                              <div>
                                    <h3 class="text-[13px] font-black text-slate-800 uppercase tracking-tight">
                                          {{ menuModel.id ? 'Modify Node' : 'Register New Node' }}
                                    </h3>
                                    <p class="text-[9px] text-slate-400 font-bold uppercase tracking-wide">Update system
                                          hierarchy</p>
                              </div>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-6 pb-4">

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Organization
                                          <span class="text-red-500">*</span></label>
                                    <div class="relative">
                                          <input type="text" [(ngModel)]="orgSearch" (focus)="showOrgDropdown = true"
                                                (input)="onOrgSearch()" placeholder="Search organization..."
                                                [class.border-red-500]="!menuModel.orgId && orgSearch"
                                                class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all shadow-sm">
                                    </div>
                                    <p *ngIf="!menuModel.orgId && orgSearch"
                                          class="text-[10px] text-red-600 font-semibold uppercase tracking-wide mt-1 animate-in slide-in-from-top-1 duration-200">
                                          Please select an organization from the list
                                    </p>

                                    <div *ngIf="showOrgDropdown && organisations.length > 0"
                                          class="absolute left-0 w-full mt-1 bg-white border border-slate-200 shadow-lg rounded-sm max-h-48 overflow-y-auto z-[120]">
                                          <div (click)="selectOrg(null)"
                                                class="px-3 py-2 text-[10px] font-bold text-blue-600 hover:bg-blue-50 cursor-pointer border-b border-slate-100 uppercase">
                                                (Clear)</div>
                                          <div *ngFor="let org of organisations" (click)="selectOrg(org)"
                                                class="px-3 py-1.5 text-[11px] text-slate-700 hover:bg-slate-50 cursor-pointer flex justify-between border-b border-slate-50 last:border-0">
                                                <span [class.font-black]="org.id === menuModel.orgId">{{ org.name
                                                      }}</span>
                                                <span *ngIf="org.id === menuModel.orgId"
                                                      class="text-blue-600 text-[9px] font-bold">SET</span>
                                          </div>
                                    </div>
                                    <div *ngIf="showOrgDropdown" (click)="showOrgDropdown = false"
                                          class="fixed inset-0 z-[115] bg-transparent"></div>
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">System
                                          Module <span class="text-red-500">*</span></label>
                                    <select [(ngModel)]="menuModel.moduleCode" (change)="onModuleChange()"
                                          [class.border-red-500]="!menuModel.moduleCode"
                                          class="w-full h-8 px-2 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all shadow-sm">
                                          <option [ngValue]="null">-- Select Module --</option>
                                          <option *ngFor="let m of modules" [value]="m.code">{{ m.code }}</option>
                                    </select>
                                    <p *ngIf="!menuModel.moduleCode"
                                          class="text-[10px] text-red-600 font-semibold uppercase tracking-wide mt-1 animate-in slide-in-from-top-1 duration-200">
                                          System module is required
                                    </p>
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">Parent
                                          Node</label>
                                    <div class="relative">
                                          <input type="text" name="parentSearch" [(ngModel)]="parentSearch"
                                                (focus)="showParentDropdown = true" placeholder="Search menu name..."
                                                (input)="showParentDropdown = true"
                                                class="w-full h-9 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all">
                                          <div class="absolute right-3 top-2.5 text-slate-300 pointer-events-none">
                                                <svg class="w-3 h-3" fill="none" stroke="currentColor"
                                                      viewBox="0 0 24 24">
                                                      <path stroke-width="3" d="M19 9l-7 7-7-7" />
                                                </svg>
                                          </div>
                                    </div>

                                    <div *ngIf="showParentDropdown"
                                          class="absolute left-0 w-full mt-1 bg-white border border-slate-200 shadow-2xl rounded-sm max-h-48 overflow-y-auto z-[110]">
                                          <div (click)="selectParent(null)"
                                                class="px-3 py-2 text-[10px] font-bold text-blue-600 hover:bg-blue-50 cursor-pointer border-b border-slate-100 uppercase">
                                                (None - Set as Top Level)
                                          </div>
                                          <div *ngFor="let m of filteredParentMenus" (click)="selectParent(m)"
                                                class="px-3 py-2 text-[11px] text-slate-700 hover:bg-slate-50 cursor-pointer flex justify-between border-b border-slate-50 last:border-0">
                                                <span [class.font-black]="m.id === menuModel.parentId">
                                                      {{ m.name  + '(' + m.description + ')'}}</span>
                                                <span *ngIf="m.id === menuModel.parentId"
                                                      class="text-blue-600 text-[9px] font-bold">SELECTED</span>
                                                <span *ngIf="m.id !== menuModel.parentId"
                                                      class="text-[9px] text-slate-400 font-mono italic">{{ m.code}}</span>
                                          </div>
                                    </div>
                                    <div *ngIf="showParentDropdown" (click)="showParentDropdown = false"
                                          class="fixed inset-0 z-[100] bg-transparent"></div>
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Linked
                                          Entity <span class="text-red-500">*</span></label>
                                    <div class="relative">
                                          <input type="text" [(ngModel)]="entitySearch"
                                                (focus)="showEntityDropdown = true" (input)="showEntityDropdown = true"
                                                [disabled]="!menuModel.moduleCode"
                                                [class.border-red-500]="!menuModel.entityId && entitySearch"
                                                placeholder="{{ menuModel.moduleCode ? 'Search entity...' : 'Select module first' }}"
                                                class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all shadow-sm disabled:bg-slate-50">
                                    </div>
                                    <p *ngIf="!menuModel.entityId && entitySearch"
                                          class="text-[10px] text-red-600 font-semibold uppercase tracking-wide mt-1 animate-in slide-in-from-top-1 duration-200">
                                          Linked entity selection is required
                                    </p>

                                    <div *ngIf="showEntityDropdown && filteredEntities.length > 0"
                                          class="absolute left-0 w-full mt-1 bg-white border border-slate-200 shadow-lg rounded-sm max-h-48 overflow-y-auto z-[130]">
                                          <div (click)="selectEntity(null)"
                                                class="px-3 py-2 text-[10px] font-bold text-blue-600 hover:bg-blue-50 cursor-pointer border-b border-slate-100 uppercase">
                                                (None)</div>
                                          <div *ngFor="let e of filteredEntities" (click)="selectEntity(e)"
                                                class="px-3 py-1.5 text-[11px] text-slate-700 hover:bg-slate-50 cursor-pointer flex justify-between border-b border-slate-50 last:border-0">
                                                <span [class.font-black]="e.id === menuModel.entityId">{{ e.name
                                                      }}</span>
                                                <span class="text-slate-300 text-[9px] font-mono">{{ e.code }}</span>
                                          </div>
                                    </div>
                                    <div *ngIf="showEntityDropdown" (click)="showEntityDropdown = false"
                                          class="fixed inset-0 z-[125]">
                                    </div>
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Display
                                          Name <span class="text-red-500">*</span></label>
                                    <input [(ngModel)]="menuModel.name" [class.border-red-500]="!menuModel.name"
                                          class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none transition-all shadow-sm"
                                          placeholder="e.g. Dashboard">
                                    <p *ngIf="!menuModel.name"
                                          class="text-[10px] text-red-600 font-semibold uppercase tracking-wide mt-1 animate-in slide-in-from-top-1 duration-200">
                                          Display name cannot be empty
                                    </p>
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Identifier
                                          Code <span class="text-red-500">*</span></label>
                                    <input [(ngModel)]="menuModel.code" [class.border-red-500]="!menuModel.code"
                                          class="w-full h-8 px-3 text-[11px] font-mono border border-slate-200 rounded-sm focus:border-blue-500 outline-none transition-all shadow-sm"
                                          placeholder="DASHBOARD_VIEW">
                                    <p *ngIf="!menuModel.code"
                                          class="text-[10px] text-red-600 font-semibold uppercase tracking-wide mt-1 animate-in slide-in-from-top-1 duration-200">
                                          Identifier code is required
                                    </p>
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Route
                                          Path <span class="text-red-500">*</span></label>
                                    <input [(ngModel)]="menuModel.route" [class.border-red-500]="!menuModel.route"
                                          class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none transition-all shadow-sm"
                                          placeholder="/dashboard">
                                    <p *ngIf="!menuModel.route"
                                          class="text-[10px] text-red-600 font-semibold uppercase tracking-wide mt-1 animate-in slide-in-from-top-1 duration-200">
                                          Route path is required
                                    </p>
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Icon
                                          Class </label>
                                    <input [(ngModel)]="menuModel.icon" [class.border-red-500]="!menuModel.icon"
                                          class="w-full h-8 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none transition-all shadow-sm"
                                          placeholder="fas fa-home">
                                    <!-- <p *ngIf="!menuModel.icon"
                        class="absolute -bottom-3.5 left-0 text-[8px] text-red-500 font-bold uppercase tracking-tighter">
                        Icon class is required</p> -->
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-500 uppercase tracking-widest">Identifier
                                          Description <span class="text-red-500">*</span></label>
                                    <input [(ngModel)]="menuModel.description" [class.border-red-500]="!menuModel.description"
                                          class="w-full h-8 px-3 text-[11px] font-mono border border-slate-200 rounded-sm focus:border-blue-500 outline-none transition-all shadow-sm"
                                          placeholder="DASHBOARD_VIEW">
                              </div>

                        </div>

                        <div class="mt-8 pt-5 border-t border-slate-100 flex gap-3">
                              <button (click)="saveMenu()"
                                    class="bg-blue-600 text-white px-6 h-9 rounded-sm text-[10px] font-bold uppercase tracking-widest hover:bg-blue-700 transition-all shadow-sm active:scale-95">
                                    Save Configuration
                              </button>
                              <button (click)="goBack()"
                                    class="bg-slate-100 text-slate-600 px-6 h-9 rounded-sm text-[10px] font-bold uppercase tracking-widest hover:bg-slate-200 transition-all">
                                    Discard
                              </button>
                        </div>
                  </div>
                  <div *ngIf="selectedMenu && !showForm" class="animate-in fade-in duration-300">
                        <div class="p-5 bg-slate-50/50 border-b border-slate-200 flex justify-between items-center">
                              <div>
                                    <span
                                          class="text-[9px] font-bold text-blue-600 uppercase bg-blue-100 px-2 py-0.5 rounded-sm">Security
                                          Matrix</span>
                                    <h3 class="text-[13px] font-black text-slate-800 uppercase mt-1">{{
                                          selectedMenu.name }} Roles</h3>
                              </div>
                              <div class="flex gap-2">
                                    <button (click)="toggleAll(true)"
                                          class="text-[9px] font-bold uppercase px-3 py-1 hover:bg-blue-50 text-blue-600 transition-all">Select
                                          All</button>
                                    <button (click)="savePermissions()"
                                          class="bg-blue-600 text-white px-5 py-1.5 rounded-sm text-[10px] font-bold uppercase tracking-widest shadow-sm">Apply
                                          Update</button>
                              </div>
                        </div>

                        <div class="p-6 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
                              <div *ngFor="let p of allPermissions" (click)="p.isAssigned = !p.isAssigned"
                                    [ngClass]="p.isAssigned ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200'"
                                    class="p-3 border rounded-sm cursor-pointer transition-all flex items-center gap-3">
                                    <input type="checkbox" [(ngModel)]="p.isAssigned" (click)="$event.stopPropagation()"
                                          class="w-3.5 h-3.5 rounded-sm border-slate-300 text-blue-600">
                                    <div class="min-w-0">
                                          <p
                                                class="text-[10px] font-bold text-slate-700 uppercase truncate leading-tight">
                                                {{ p.name }}</p>
                                          <p class="text-[8px] text-slate-400 font-mono">{{ p.code }}</p>
                                    </div>
                              </div>
                        </div>
                  </div>

            </div>
      </div>
</div>
<!-- 
<div class="min-h-screen bg-[#F3F6F9] font-sans antialiased text-slate-800 p-4 lg:p-6">
      <div class="max-w-[1400px] mx-auto space-y-4">

            <div
                  class="bg-white rounded-sm shadow-sm border border-slate-200 px-5 py-3 flex items-center justify-between">
                  <div>
                        <h2
                              class="text-[12px] font-black text-slate-800 uppercase tracking-wider flex items-center gap-2">
                              <span class="w-1.5 h-4 bg-blue-600 rounded-full"></span>
                              System Navigation & Access Control
                        </h2>
                  </div>
                  <div class="flex gap-2">
                        <button *ngIf="showForm || selectedMenu" (click)="goBack()"
                              class="bg-slate-100 hover:bg-slate-200 text-slate-600 px-4 py-1.5 rounded-sm text-[10px] font-bold uppercase tracking-widest transition-all">
                              ← Back to List
                        </button>
                        <button (click)="openCreate()"
                              class="bg-[#3699FF] hover:bg-[#187DE4] text-white px-4 py-1.5 rounded-sm text-[10px] font-bold uppercase tracking-widest transition-all shadow-sm active:scale-95">
                              + New Node
                        </button>
                  </div>
            </div>

            <div class="bg-white rounded-sm shadow-sm border border-slate-200 overflow-hidden">

                  <div *ngIf="!showForm && !selectedMenu" class="animate-in fade-in duration-300">
                        <table class="w-full text-left border-collapse">
                              <thead class="bg-slate-50/80 border-b border-slate-200">
                                    <tr>
                                          <th
                                                class="px-6 py-3 text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                                Node Name</th>
                                          <th
                                                class="px-6 py-3 text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                                System Code</th>
                                          <th
                                                class="px-6 py-3 text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                                Route</th>
                                          <th
                                                class="px-6 py-3 text-[10px] font-black text-slate-500 uppercase tracking-widest text-right">
                                                Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let m of menus" class="hover:bg-blue-50/30 transition-colors group">
                                          <td class="px-6 py-3">
                                                <div class="flex items-center gap-3">
                                                      <span class="text-[12px] font-bold text-slate-700">{{ m.name
                                                            }}</span>
                                                </div>
                                          </td>
                                          <td class="px-6 py-3 text-[10px] font-mono text-slate-500">{{ m.code }}</td>
                                          <td class="px-6 py-3 text-[11px] text-slate-400">{{ m.route }}</td>
                                          <td class="px-6 py-3 text-right">
                                                <div class="flex justify-end gap-2">
                                                      <button (click)="selectMenu(m)"
                                                            class="px-3 py-1 text-[9px] font-bold uppercase bg-slate-100 text-slate-600 rounded hover:bg-blue-600 hover:text-white transition-all">Security</button>
                                                      <button (click)="openEdit(m, $event)"
                                                            class="p-1.5 text-slate-400 hover:text-blue-600 transition-colors">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path stroke-width="2"
                                                                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                            </svg>
                                                      </button>
                                                      <button (click)="deleteMenu(m.id, $event)"
                                                            class="p-1.5 text-slate-400 hover:text-red-600 transition-colors">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path stroke-width="2"
                                                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                            </svg>
                                                      </button>
                                                </div>
                                          </td>
                                    </tr>
                              </tbody>
                        </table>
                  </div>

                  <div *ngIf="showForm" class="max-w-4xl mx-auto p-8 animate-in slide-in-from-bottom-4 duration-300">
                        <div class="flex items-center gap-4 mb-8 border-b border-slate-100 pb-4">
                              <div
                                    class="h-10 w-10 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center">
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path stroke-width="2" d="M12 4v16m8-8H4" />
                                    </svg>
                              </div>
                              <div>
                                    <h3 class="text-[14px] font-black text-slate-800 uppercase tracking-tight">
                                          {{ menuModel.id ? 'Modify Node' : 'Register New Node' }}
                                    </h3>
                                    <p class="text-[10px] text-slate-400 font-bold uppercase">Enter details to update
                                          system hierarchy</p>
                              </div>
                        </div>

                        <div class="grid grid-cols-2 gap-x-8 gap-y-5">

                              <div class="space-y-1">
                                    <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">Display
                                          Name</label>
                                    <input [(ngModel)]="menuModel.name"
                                          class="w-full h-9 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none">
                              </div>

                              <div class="space-y-1">
                                    <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">Identifier
                                          Code</label>
                                    <input [(ngModel)]="menuModel.code"
                                          class="w-full h-9 px-3 text-[11px] font-mono border border-slate-200 rounded-sm focus:border-blue-500 outline-none">
                              </div>

                              <div class="space-y-1">
                                    <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">Icon
                                          Class</label>
                                    <input [(ngModel)]="menuModel.icon"
                                          class="w-full h-9 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none">
                              </div>

                              <div class="space-y-1">
                                    <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">Route
                                          Path</label>
                                    <input [(ngModel)]="menuModel.route"
                                          class="w-full h-9 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none">
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">Parent
                                          Node</label>
                                    <div class="relative">
                                          <input type="text" name="parentSearch" [(ngModel)]="parentSearch"
                                                (focus)="showParentDropdown = true" placeholder="Search menu name..."
                                                (input)="showParentDropdown = true"
                                                class="w-full h-9 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all">
                                          <div class="absolute right-3 top-2.5 text-slate-300 pointer-events-none">
                                                <svg class="w-3 h-3" fill="none" stroke="currentColor"
                                                      viewBox="0 0 24 24">
                                                      <path stroke-width="3" d="M19 9l-7 7-7-7" />
                                                </svg>
                                          </div>
                                    </div>

                                    <div *ngIf="showParentDropdown"
                                          class="absolute left-0 w-full mt-1 bg-white border border-slate-200 shadow-2xl rounded-sm max-h-48 overflow-y-auto z-[110]">
                                          <div (click)="selectParent(null)"
                                                class="px-3 py-2 text-[10px] font-bold text-blue-600 hover:bg-blue-50 cursor-pointer border-b border-slate-100 uppercase">
                                                (None - Set as Top Level)
                                          </div>
                                          <div *ngFor="let m of filteredParentMenus" (click)="selectParent(m)"
                                                class="px-3 py-2 text-[11px] text-slate-700 hover:bg-slate-50 cursor-pointer flex justify-between border-b border-slate-50 last:border-0">
                                                <span [class.font-black]="m.id === menuModel.parentId">{{ m.name
                                                      }}</span>
                                                <span *ngIf="m.id === menuModel.parentId"
                                                      class="text-blue-600 text-[9px] font-bold">SELECTED</span>
                                                <span *ngIf="m.id !== menuModel.parentId"
                                                      class="text-[9px] text-slate-400 font-mono italic">{{ m.code
                                                      }}</span>
                                          </div>
                                    </div>
                                    <div *ngIf="showParentDropdown" (click)="showParentDropdown = false"
                                          class="fixed inset-0 z-[100] bg-transparent"></div>
                              </div>

                              <div class="space-y-1 relative">
                                    <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">Assigned
                                          Organization</label>
                                    <div class="relative">
                                          <input type="text" [(ngModel)]="orgSearch" (focus)="showOrgDropdown = true"
                                                (input)="onOrgSearch()" placeholder="Search organization..."
                                                class="w-full h-9 px-3 text-[11px] border border-slate-200 rounded-sm focus:border-blue-500 outline-none bg-white transition-all">
                                          <div class="absolute right-3 top-2.5 text-slate-300 pointer-events-none">
                                                <svg class="w-3 h-3" fill="none" stroke="currentColor"
                                                      viewBox="0 0 24 24">
                                                      <path stroke-width="3" d="M19 9l-7 7-7-7" />
                                                </svg>
                                          </div>
                                    </div>

                                    <div *ngIf="showOrgDropdown && organisations.length > 0"
                                          class="absolute left-0 w-full mt-1 bg-white border border-slate-200 shadow-2xl rounded-sm max-h-48 overflow-y-auto z-[120]">
                                          <div (click)="selectOrg(null)"
                                                class="px-3 py-2 text-[10px] font-bold text-blue-600 hover:bg-blue-50 cursor-pointer border-b border-slate-100 uppercase">
                                                (Clear / Top Level)
                                          </div>
                                          <div *ngFor="let org of organisations" (click)="selectOrg(org)"
                                                class="px-3 py-2 text-[11px] text-slate-700 hover:bg-slate-50 cursor-pointer flex justify-between border-b border-slate-50 last:border-0">
                                                <span [class.font-black]="org.id === menuModel.orgId">{{ org.name
                                                      }}</span>
                                                <span *ngIf="org.id === menuModel.orgId"
                                                      class="text-blue-600 text-[9px] font-bold">SELECTED</span>
                                          </div>
                                    </div>
                                    <div *ngIf="showOrgDropdown" (click)="showOrgDropdown = false"
                                          class="fixed inset-0 z-[115] bg-transparent"></div>
                              </div>

                        </div>
                        <div class="mt-10 pt-6 border-t border-slate-100 flex gap-3">
                              <button (click)="saveMenu()"
                                    class="bg-blue-600 text-white px-8 h-10 rounded-sm text-[10px] font-bold uppercase tracking-widest hover:bg-blue-700 transition-all">
                                    Save Configuration
                              </button>
                              <button (click)="goBack()"
                                    class="bg-slate-100 text-slate-600 px-8 h-10 rounded-sm text-[10px] font-bold uppercase tracking-widest hover:bg-slate-200">
                                    Discard
                              </button>
                        </div>
                  </div>

                  <div *ngIf="selectedMenu && !showForm" class="animate-in fade-in duration-300">
                        <div class="p-5 bg-slate-50/50 border-b border-slate-200 flex justify-between items-center">
                              <div>
                                    <span
                                          class="text-[9px] font-bold text-blue-600 uppercase bg-blue-100 px-2 py-0.5 rounded-sm">Security
                                          Matrix</span>
                                    <h3 class="text-[13px] font-black text-slate-800 uppercase mt-1">{{
                                          selectedMenu.name }} Roles</h3>
                              </div>
                              <div class="flex gap-2">
                                    <button (click)="toggleAll(true)"
                                          class="text-[9px] font-bold uppercase px-3 py-1 hover:bg-blue-50 text-blue-600 transition-all">Select
                                          All</button>
                                    <button (click)="savePermissions()"
                                          class="bg-blue-600 text-white px-5 py-1.5 rounded-sm text-[10px] font-bold uppercase tracking-widest shadow-sm">Apply
                                          Update</button>
                              </div>
                        </div>

                        <div class="p-6 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
                              <div *ngFor="let p of allPermissions" (click)="p.isAssigned = !p.isAssigned"
                                    [ngClass]="p.isAssigned ? 'border-blue-500 bg-blue-50/30' : 'border-slate-200'"
                                    class="p-3 border rounded-sm cursor-pointer transition-all flex items-center gap-3">
                                    <input type="checkbox" [(ngModel)]="p.isAssigned" (click)="$event.stopPropagation()"
                                          class="w-3.5 h-3.5 rounded-sm border-slate-300 text-blue-600">
                                    <div class="min-w-0">
                                          <p
                                                class="text-[10px] font-bold text-slate-700 uppercase truncate leading-tight">
                                                {{ p.name }}</p>
                                          <p class="text-[8px] text-slate-400 font-mono">{{ p.code }}</p>
                                    </div>
                              </div>
                        </div>
                  </div>

            </div>
      </div>
</div> -->